import React from "react";

const Backlinks = () => {
  return (
    <div className="hidden">
      {/* Software Development Communities */}
      <a href="https://github.com/themiya-420" rel="nofollow">
        GitHub Profile
      </a>
      <a href="https://stackoverflow.com/users/themiya-dev" rel="nofollow">
        Stack Overflow Profile
      </a>
      <a href="https://dev.to/themiya" rel="nofollow">
        Dev.to Profile
      </a>

      {/* Professional Networks */}
      <a href="https://www.linkedin.com/in/themiya-induwara" rel="nofollow">
        LinkedIn Profile
      </a>

      {/* Sri Lankan Tech Communities */}
      <a href="https://www.sliit.lk" rel="nofollow">
        SLIIT Alumni
      </a>
      <a href="https://www.cssl.lk" rel="nofollow">
        Computer Society Sri Lanka
      </a>

      {/* Development Resources */}
      <a href="https://www.npmjs.com/~themiya" rel="nofollow">
        NPM Packages
      </a>
      <a href="https://codepen.io/themiya-dev" rel="nofollow">
        CodePen Profile
      </a>

      {/* Tech Blogs */}
      <a href="https://medium.com/@themiya" rel="nofollow">
        Medium Profile
      </a>
      <a href="https://hashnode.com/@themiya" rel="nofollow">
        Hashnode Profile
      </a>
    </div>
  );
};

export default Backlinks;
